import { User } from "firebase/auth";

const BASE = process.env.REACT_APP_API_URL ?? "";

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = "ApiError";
  }
}

async function getToken(user: User): Promise<string> {
  return user.getIdToken();
}

export async function apiFetch<T>(
  user: User,
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = await getToken(user);
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers ?? {}),
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new ApiError(res.status, body.error ?? res.statusText);
  }
  if (res.status === 204) return undefined as unknown as T;
  return res.json();
}
